<div [ngClass]="_containerClass">
    <div class="">
        <div class="timePicker-container">
            <div
                *ngIf="showHours"
                class="timePicker-container-section timePicker-container-section--hours"
                [ngClass]="{
                    'timePicker-container-section--noRadius-right': _columnsShown > 1,
                    'timePicker-container-section--showArrow': _columnsShown < 2
                }"
            >
                <emma-select
                    [items]="hoursOptions"
                    [(ngModel)]="hours"
                    ($change)="onChange()"
                    ($blur)="onBlur()"
                    [searchable]="true"
                    [required]="!!required"
                    [readonly]="readonly"
                    [disabled]="disabled"
                    [color]="color"
                    dropdownPosition="bottom"
                    placeholder="Hora"
                    i18n-placeholder
                ></emma-select>
            </div>
            <div
                *ngIf="showMinutes && (!showHours || hours || hours === 0)"
                class="timePicker-container-section timePicker-container-section--minutes timePicker-container-section--noRadius-left"
                [ngClass]="{
                    'timePicker-container-section--noRadius-right': _columnsShown > 2
                }"
            >
                <div class="timePicker-container-section--separator">
                    <span>:</span>
                </div>
                <emma-select
                    [items]="minutesOptions"
                    [(ngModel)]="minutes"
                    ($change)="onChange()"
                    ($blur)="onBlur()"
                    [searchable]="true"
                    [required]="!!required"
                    [readonly]="readonly"
                    [disabled]="disabled"
                    [color]="color"
                    dropdownPosition="bottom"
                    placeholder="Minuto"
                    i18n-placeholder
                ></emma-select>
            </div>
            <div
                *ngIf="showSeconds && (!showMinutes || minutes || minutes === 0)"
                class="timePicker-container-section timePicker-container-section--seconds timePicker-container-section--noRadius-left"
            >
                <div class="timePicker-container-section--separator">
                    <span>:</span>
                </div>
                <emma-select
                    [items]="secondsOptions"
                    [(ngModel)]="seconds"
                    ($change)="onChange()"
                    ($blur)="onBlur()"
                    [searchable]="true"
                    [required]="!!required"
                    [readonly]="readonly"
                    [disabled]="disabled"
                    [color]="color"
                    dropdownPosition="bottom"
                    placeholder="Segundo"
                    i18n-placeholder
                ></emma-select>
            </div>
        </div>
    </div>
</div>
